import React from "react";
import { Box, Typography } from "@mui/material";
import { useQuery } from "react-query";
import axios from "axios";
import DashboardOutlinedIcon     from "@mui/icons-material/DashboardOutlined";
import GroupsOutlinedIcon        from "@mui/icons-material/GroupsOutlined";
import CloudUploadOutlinedIcon   from "@mui/icons-material/CloudUploadOutlined";
import AssessmentOutlinedIcon    from "@mui/icons-material/AssessmentOutlined";
import PersonOutlinedIcon        from "@mui/icons-material/PersonOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LocationCityOutlinedIcon  from "@mui/icons-material/LocationCityOutlined";
import StyleOutlinedIcon         from "@mui/icons-material/StyleOutlined";
import CampaignOutlinedIcon      from "@mui/icons-material/CampaignOutlined";
import EventNoteOutlinedIcon        from "@mui/icons-material/EventNoteOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import DrawerListItem from "../Components/DrawerListItem";
import withAuth from "../../../Hoc/withAuth";
import { useSidebarAccent } from "../SidebarAccentContext";

const NavSection = ({ label, children, minimized }) => (
  <Box sx={{ mb: 0.5 }}>
    {!minimized && (
      <Typography
        sx={{
          px: 2.25, py: 0.75,
          fontSize: "0.6875rem", fontWeight: 700,
          letterSpacing: "0.1em", textTransform: "uppercase",
          color: "text.disabled",
        }}
      >
        {label}
      </Typography>
    )}
    {children}
  </Box>
);

const TeacherDrawer = ({ token }) => {
  const { minimized } = useSidebarAccent();

  const { data: assignment } = useQuery(
    "teacherMe",
    () =>
      axios
        .get(`${process.env.REACT_APP_PUBLIC_URL}/teachers/me`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((r) => r.data),
    { retry: false, enabled: !!token },
  );

  // Only approved teachers belong to a school whose notice board they can manage
  const orgId = assignment?.approved === true ? assignment?.org_id : null;

  // Org uuid is used for the event-management routes (/myEvents/:uuid, /CreateEvent/:uuid)
  const orgUuid = assignment?.approved === true ? assignment?.Org?.uuid : null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", py: 1 }}>
      <Box sx={{ flex: 1, overflowY: "auto", pb: 2 }}>

        <NavSection label="Overview" minimized={minimized}>
          <DrawerListItem name="Dashboard" path="teacher/dashboard" Icon={DashboardOutlinedIcon} />
        </NavSection>

        <NavSection label="Discover" minimized={minimized}>
          <DrawerListItem name="Events"        path="Events"     Icon={CalendarMonthOutlinedIcon} />
          <DrawerListItem name="Organisations" path="orgs"       Icon={LocationCityOutlinedIcon} />
          <DrawerListItem name="Causes"        path="CausesList" Icon={StyleOutlinedIcon} />
        </NavSection>

        <NavSection label="My Class" minimized={minimized}>
          <DrawerListItem name="My Class"    path="teacher/myClass"  Icon={GroupsOutlinedIcon} />
          <DrawerListItem name="Uploads"     path="teacher/uploads"  Icon={CloudUploadOutlinedIcon} />
          <DrawerListItem name="Class Stats" path="teacher/stats"    Icon={AssessmentOutlinedIcon} />
          {orgId && (
            <DrawerListItem name="Notice Board" path={`mySchool/${orgId}`} Icon={CampaignOutlinedIcon} />
          )}
        </NavSection>

        {orgUuid && (
          <NavSection label="Events" minimized={minimized}>
            <DrawerListItem name="My Events"    path={`myEvents/${orgUuid}`}    Icon={EventNoteOutlinedIcon} />
            <DrawerListItem name="Create Event" path={`CreateEvent/${orgUuid}`} Icon={AddCircleOutlineOutlinedIcon} />
          </NavSection>
        )}

        <NavSection label="Account" minimized={minimized}>
          <DrawerListItem name="My Profile" path="profile" Icon={PersonOutlinedIcon} />
        </NavSection>

      </Box>
    </Box>
  );
};

export default withAuth(TeacherDrawer);
